import { useEffect, useState } from "react"
import { Box, Card, CardContent, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material"
import { Area, AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import useFetch 	from "../api/api"
import Loading 		from "./Loading"
import config from "../common/Config";

const PortfolioHistoryByAsset = () => {

	const privateFetch 								= useFetch()
	const [portfolioHistory, setPortfolioHistory] 	= useState()

	const colors		= ['#FFC0CB','#FF8C00','#BA55D3','#32CD32','#40E0D0','#00BFFF','#696969','#F4A460']
	const friendlyNames	= {
		'TESOURODIRETO' : 'Tesouro Direto',
		'STOCK'			: 'Stocks',
		'FII'			: 'FIIs',
		'CASH'			: 'Dinheiro',
		'BOND'			: 'Bonds',
		'ACAO'			: 'Açoes'
	}
	
	useEffect(() => {
		privateFetch(config.apiUrl +'/api/portfolio/history/byAsset')
		.then(data => data.json())
		.then(data => {
			let currentHistory = []

			data.map(ph => {
				let index = currentHistory.findIndex(ch => ch.date === ph.date)

				if (index >= 0){
					currentHistory[index][ph.assetType] = ph.total

				}
				else {
					currentHistory.push({
						date 			: ph.date,
						[ph.assetType] 	: ph.total
					})
				}
			})

			setPortfolioHistory(currentHistory)
		})
	}, [])

	return (
		portfolioHistory?.length > 0 
		? 
		<ResponsiveContainer width="98%" height={400}>
			
			<AreaChart 
				width={1000}
				height={400}
				data={portfolioHistory}
				margin={{
					top: 50,
					right: 5,
					left: 20,
					bottom: 5,
				}}
				>
				<defs>
					{
						Object.keys(portfolioHistory[portfolioHistory.length-1]).map( (ph, index) => {
							return (ph !== 'date' && ph !== 'TOTAL') ? 
								<linearGradient key={ph} id={ph} x1="0" y1="0" x2="0" y2="1">
									<stop offset="5%" stopColor={colors[index]} stopOpacity={0.8}/>
									<stop offset="95%" stopColor={colors[index]} stopOpacity={0}/>
								</linearGradient>
							: null
						})
					}
				</defs>
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis dataKey="date" tickFormatter={(item) => new Date(item).toLocaleDateString('pt-BR', {timeZone: 'UTC'})} style={{fontSize: 10}}/>
				<YAxis 
					yAxisId="left" 
					tickFormatter={(item) => item.toFixed(0)} 
					style={{fontSize: 10}} 
					/> 
				<Tooltip content={<CustomTooltip/>} />
				<Legend style={{fontSize: 12}}/>
				{
					Object.keys(portfolioHistory[portfolioHistory.length-1]).map((ph, index) => {
						return (ph !== 'date' && ph !== 'TOTAL') 
							? <Area yAxisId="left" key={ph} stackId="1" connectNulls type="monotone" dataKey={ph} name={friendlyNames[ph]} dot={false} stroke={colors[index]} fill={'url(#'+ ph +')'} /> 
							: null 
					})						
				}
			</AreaChart>
			</ResponsiveContainer>
			
		: portfolioHistory ? <Box height={400}><Typography paddingTop={5} paddingLeft={3}>No history found!</Typography></Box> : <Loading/>
		
	)
}

const CustomTooltip = ({ active, payload, label }) => {

	const currencyFormat = new Intl.NumberFormat('pt-BR', {
		style : "currency",
		currency : "BRL",
		maximumFractionDigits: 0, 
		minimumFractionDigits: 0, 
	})

	return (
		<Card>
			<CardContent>
				<Stack spacing={1}>
					<Typography align="center" sx={{fontWeight:"bold"}}>Posição em {new Date(label).toLocaleDateString("pt-BR", { timeZone: "UTC"})}</Typography>
					<Table size="small">
						<TableBody>
						{payload.map(p => (
							<TableRow key={"key_"+ p.name}>
								<TableCell sx={{color: p.stroke}}>{p.name}</TableCell>
								<TableCell sx={{color: p.stroke}}>{currencyFormat.format(p.value)}</TableCell>
							</TableRow>
						))}
						</TableBody>
					</Table>
				</Stack>
			</CardContent>
		</Card>
	)
}

export default PortfolioHistoryByAsset